import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostIssueLottery = (params, setOpenModal) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_ISSUE_PRIZE_LOTTERY
            });
            setOpenModal(true)

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostIssueLottery as SetPostIssueLottery
}